import React from 'react';
import { Grid, TextField, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import FadeIn from '../../../../../../Animations/FadeIn/FadeIn';

const Root = styled(FadeIn)(({ theme }) => ({
	width: '100%',
	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'center',
	alignItems: 'center',
	gap: '40px'
}));

const TitlesContainer = styled(Grid)(({ theme }) => ({
	marginBottom: 20,
	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'center',
	alignItems: 'center',
	gap: '10px'
}));

const Title = styled(Typography)(({ theme }) => ({
	fontSize: '1.7rem',
	textAlign: 'center'
}));

const SecondaryTitle = styled(Typography)(({ theme }) => ({
	maxWidth: 450,
	fontSize: '0.9rem',
	color: theme.palette.text.tertiary,
	textAlign: 'center',
	fontWeight: 300
}));

const TitleInput = styled(TextField)(({ theme }) => ({
	width: '95%',
	maxWidth: 600
}));

const DescriptionInput = styled(TextField)(({ theme }) => ({
	width: '95%',
	maxWidth: 600
}));

function TitleAndDescription({ data, setData, errs }) {
	return (
		<Root>
			<TitlesContainer>
				<Title>What would you like to name your gallery?</Title>
				<SecondaryTitle>
					The gallery title and description will be shown on the gallery cover and will be
					displayed when sharing the gallery link.
				</SecondaryTitle>
			</TitlesContainer>
			<TitleInput
				label="Gallery Title"
				placeholder="e.g. Dan & Rachel's Engagement"
				InputLabelProps={{ shrink: true }}
				value={data?.title}
				error={errs?.title}
				helperText={errs?.title}
				onChange={(e) => setData({ ...data, title: e?.target?.value })}
			/>
			<DescriptionInput
				label="Gallery Description"
				InputLabelProps={{ shrink: true }}
				value={data?.description}
				error={errs?.description}
				helperText={errs?.description}
				onChange={(e) => setData({ ...data, description: e?.target?.value })}
				placeholder={`e.g. ${new Date().toLocaleDateString('en-US', {
					year: 'numeric',
					month: 'long',
					day: 'numeric'
				})}`}
			/>
		</Root>
	);
}

export default TitleAndDescription;
